var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.getContainerStyle),attrs:{"id":"fg-container"}},[_c('div',{attrs:{"id":"force-graph"}}),_c('div',{attrs:{"id":"force-tooltip"}},[_c('ForceToolTip',{attrs:{"hovered":_vm.hovered,"artistData":_vm.artistData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }